import { Button, Paragraph, Stack, Strong, Tooltip, TooltipContent } from '@customerio/pluma-components/react';
import clsx from 'clsx';
import { FlexMark, leadingMarkButton } from '@/components/flex-mark';
import { SEGMENTS_ADDON_PRICE } from '../utils/addon-purchase';
import * as styles from './segments-addon-button.css';

const TOOLTIP_BODY = `Unlimited is a ${SEGMENTS_ADDON_PRICE} per billing cycle add-on, prorated for the rest of this cycle and billed to your card, not your credit balance.`;

type SegmentsAddonButtonProps = {
  onClick: () => void;
  /** Inside a caution banner: a plain secondary button with the mark in the banner's colours. */
  tone?: 'caution';
  /**
   * The tooltip's first line, for a button standing alone. Where text beside it already explains
   * the add-on, leave it out.
   */
  tooltipTitle?: string;
};

/**
 * The Credits Lifecycle prototype's "Flex add-on" tag, offered at the data-driven segment cap. It is a small Pluma
 * Button because Pluma's Badge and Tag are not actions.
 */
export function SegmentsAddonButton({ onClick, tone, tooltipTitle }: SegmentsAddonButtonProps) {
  const isCaution = tone === 'caution';

  // Custom, so the tooltip anchors to this button rather than wrapping it in a trigger button of its own.
  return (
    <Tooltip isCustom isDisabled={tooltipTitle == null} placement="top">
      {(context) => (
        <>
          <Button
            ref={context.reference.setReference}
            {...context.reference.getReferenceProps()}
            className={isCaution ? leadingMarkButton : clsx(styles.flexTag, leadingMarkButton)}
            variant={isCaution ? 'secondary' : undefined}
            size="sm"
            elementBefore={<FlexMark tone={tone} />}
            onClick={onClick}
          >
            Flex add-on
          </Button>
          {tooltipTitle == null ? null : (
            <TooltipContent>
              <Stack gap="050" textAlign="left">
                <Paragraph color="inherit">
                  <Strong>{tooltipTitle}</Strong>
                </Paragraph>
                <Paragraph color="inherit">{TOOLTIP_BODY}</Paragraph>
              </Stack>
            </TooltipContent>
          )}
        </>
      )}
    </Tooltip>
  );
}
